import React from "react";
import { Card, Col } from "react-bootstrap";

interface QuestionState {
  question: any;
}
const AssessmentCardQuestion = ({ question }: QuestionState) => {
  return (
    <Card className="mb-2">
      <Card.Body className="px-3 py-2">
        <Col xs={12}>{question?.question}</Col>
      </Card.Body>
    </Card>
  );
};

export default AssessmentCardQuestion;
